<template>
  <div>
    <div class="bb-navigation uk-visible@m">
      <p class="label">Steps:</p>
      <ul class="bb-steps">
        <li :class="isActiveClass('choose-size')">
          <router-link :to="{ name: 'choose-size' }"><span>1</span> Bed Size</router-link>
        </li>
        <li :class="isActiveClass('wood-finish')">
          <router-link :to="{ name: 'wood-finish' }"><span>2</span> Wood Finish</router-link>
        </li>
        <li :class="isActiveClass('additions')">
          <router-link :to="{ name: 'additions' }"><span>3</span> Additions</router-link>
        </li>
        <li :class="isActiveClass(['left_cabinet','right_cabinet'])">
          <router-link :to="{ name: 'left_cabinet' }"><span>4</span> Cabinets</router-link>
        </li>
        <li :class="isActiveClass('mattress')">
          <router-link :to="{ name: 'mattress' }"><span>5</span> Mattress</router-link>
        </li>
        <li :class="isActiveClass('summary')">
          <router-link :to="{ name: 'summary' }"><span>6</span> Summary</router-link>
        </li>
      </ul>
    </div>
    <div class="bb-mobile-navigation uk-hidden@m">
        <div class="uk-position-relative" uk-slider="finite: true; center: true" tabindex="-1">
            <ul class="uk-slider-items uk-flex uk-flex-middle uk-grid-collapse bb-steps">
                <li :class="isActiveClass('choose-size')" class="uk-width-1-2">
                    <router-link :to="{ name: 'choose-size' }"><span>1</span> Bed Size</router-link>
                </li>
                <li :class="isActiveClass('wood-finish')" class="uk-width-1-2">
                    <router-link :to="{ name: 'wood-finish' }"><span>2</span> Wood Finish</router-link>
                </li>
                <li :class="isActiveClass('additions')" class="uk-width-1-2">
                    <router-link :to="{ name: 'additions' }"><span>3</span> Additions</router-link>
                </li>
                <li :class="isActiveClass('cabinets')" class="uk-width-1-2">
                    <router-link :to="{ name: 'cabinets' }"><span>4</span> Cabinets</router-link>
                </li>
                <li :class="isActiveClass('mattress')" class="uk-width-1-2">
                    <router-link :to="{ name: 'mattress' }"><span>5</span> Mattress</router-link>
                </li>
                <li :class="isActiveClass('summary')" class="uk-width-1-2">
                    <router-link :to="{ name: 'summary' }"><span>6</span> Summary</router-link>
                </li>
                <li class="uk-hidden@s uk-width-1-2">
                    <a href="#" class="button outline gold" uk-toggle="target:#request-follow">Request Follow-Up</a>
                </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>
        </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    name: "steps-navigation",
    components: {},
    methods: {
      /**
       * reutrn 'active' class name if that nav item is the current one
       * @param  {[type]}  name [description]
       * @return {Boolean}      [description]
       */
      isActiveClass(name) {
        if(Array.isArray(name)){
          return name.indexOf(this.current_step) !== -1 ? "active" : "";
        }else{
          return this.current_step == name ? "active" : "";
        }
      },
    },
    computed: {
      ...mapState({
        current_step: (state) => state.current_step,
      }),
    },
  };
</script>